<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <h1
      v-if="actionType === 'edit'"
      class="text-primary mb-5 font-45px mt-xl-2"
    >
      {{ $t("documents_informations") }}
    </h1>

    <div class="giga-upload_files_list">
      <template v-for="(document, index) in documents">
        <div :key="index">
          <div
            class="giga-upload_file_item"
            v-if="document.fileName"
            :key="document.fileName"
          >
            <div class="giga-upload_file_action">
              <button
                class="upload_file_delete_action"
                @click.prevent="deleteDraft(document)"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.256 8L15.52 2.736C15.824 2.448 16 2.048 16 1.6C16 0.72 15.28 0 14.4 0C13.952 0 13.552 0.176 13.264 0.464L8 5.744L2.736 0.464C2.448 0.176 2.048 0 1.6 0C0.72 0 0 0.72 0 1.6C0 2.048 0.176 2.448 0.464 2.736L5.744 8L0.48 13.264C0.176 13.552 0 13.952 0 14.4C0 15.28 0.72 16 1.6 16C2.048 16 2.448 15.824 2.736 15.536L8 10.256L13.264 15.52C13.552 15.824 13.952 16 14.4 16C15.28 16 16 15.28 16 14.4C16 13.952 15.824 13.552 15.536 13.264L10.256 8Z"
                    fill="#6B829A"
                  />
                </svg>
              </button>
            </div>
            <div class="giga-upload_file_name">
              <i class="extention-icon">
                <img
                  v-if="getFileExtention(document.originalFileName) == 'xlsx'"
                  src="~@/assets/images/extensions/xls.svg"
                />
                <img
                  v-else-if="
                    getFileExtention(document.originalFileName) == 'txt'
                  "
                  src="~@/assets/images/extensions/txt.svg"
                />
                <img
                  v-else-if="
                    getFileExtention(document.originalFileName) == 'pdf'
                  "
                  src="~@/assets/images/extensions/pdf.svg"
                />
                <img
                  v-else-if="
                    getFileExtention(document.originalFileName) == 'docx'
                  "
                  src="~@/assets/images/extensions/doc.svg"
                />
                <img
                  v-else-if="
                    getFileExtention(document.originalFileName) == 'doc'
                  "
                  src="~@/assets/images/extensions/doc.svg"
                />
                <img
                  v-else-if="
                    getFileExtention(document.originalFileName) == 'zip'
                  "
                  src="~@/assets/images/extensions/zip.svg"
                />
                <img v-else src="~@/assets/images/extensions/text.svg" />
              </i>
              {{ document.originalFileName }}
            </div>
            <div class="giga-upload_file_progress progress c-progress">
              <div
                :class="{
                  'progress-bar': true,
                  'bg-danger': !files[index].success,
                  'progress-bar-animated': files[index].active
                }"
                role="progressbar"
                :style="{ width: files[index].progress + '%' }"
              ></div>
            </div>
            <lottie-player
              v-if="isPreviewInProgress"
              class="gwt-loader"
              src="https://assets10.lottiefiles.com/private_files/lf30_yxonmdwh.json"
              background="transparent"
              speed="1.8"
              loop
              autoplay
            ></lottie-player>
          </div>
        </div>
      </template>
    </div>
    <VuePerfectScrollbar class="documents-scroll-area"> </VuePerfectScrollbar>
    <!-- </b-card> -->

    <b-card
      v-if="actionType === 'edit'"
      class="border-raduis-xl border-color-muted box-shadow-sm mt-4"
      body-class="p-3"
    >
      <b-row align-v="center">
        <b-col>
          <b-button
            :disabled="isDisabled"
            @click="editDocumentType"
            pill
            variant="primary"
            class="py-2 px-5"
          >
            <span> {{ $t("save") }} </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- </b-col>
    </b-row> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { map } from "lodash";
import eventBus from "@/shared/event.bus";

export default {
  name: "ListEstimationInMassDoc",
  data() {
    return {
      value: []
    };
  },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    files: {
      type: Array,
      default: () => []
    },
    actionType: {
      type: String,
      default: "add"
    },
    replace: {
      type: Boolean,
      default: false
    },
    isPreviewInProgress: {
      type: Boolean,
      default: false
    },
    estimationsPreview: {
      type: Array,
      default: null
    },
    rejects: {
      type: Array,
      default: null
    }
  },
  mounted() {},
  methods: {
    ...mapMutations("document", [
      "setDraftDocuments",
      "setDraftDocumentsReplace",
      "setDraftImportInMassDocuments"
    ]),
    ...mapActions("document", [
      "getDocumentsTypesAction",
      "editDocumentTypesAction",
      "deleteDraftDocumentsAction"
    ]),
    editDocumentType() {
      const editedDocs = [];
      this.documents.forEach(document => {
        const types = document.types;
        editedDocs.push({ id: document.id, types: map(types, "code") });
      });
      this.$root.$emit("bv::hide::modal", "EditDocumentTypes");
      this.editDocumentTypesAction({ documents: editedDocs });
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    deleteDraft(document) {
      const documents = this.documents.filter(
        d => d.fileName !== document.fileName
      );
      this.setDraftImportInMassDocuments(documents);
      this.$emit("draft-deleted");
    }
  },
  watch: {
    // when draft documents are added or removed from upload section
    documents() {
      if (this.documents) {
        const event =
          this.documents.some(d => !d.types || d.types.length === 0) ||
          this.documents.length === 0;
        eventBus.$emit("field-required", event);
      }
    },
    deep: true
  },
  computed: {
    ...mapGetters("document", ["getDocumentsTypes", "getDraftDocuments"]),
    isDisabled() {
      let flag = false;
      if (this.documents && this.documents.length) {
        this.documents.forEach(document => {
          if (!document.types || document.types < 1) {
            flag = true;
          }
        });
      }
      return flag;
    }
  },
  beforeDestroy() {
    eventBus.$off("check-docs");
  }
};
</script>
<style lang="scss">
.documents-scroll-area {
  max-height: 340px;
}
.gwt-loader {
  width: 40px;
  height: 50px;
  margin-left: auto;
}
</style>
